import { createLinkedHeadingGuardPlugin } from '@/components/tiptap/shared/linked-heading-guard';
import {
  handleSectionHeadingEnter,
  handleSectionShiftTab,
  handleSectionTab,
} from '@/components/tiptap/shared/section-keyboard-navigation';
import { sectionNodeSchemaSpec } from '@/components/tiptap/shared/section-node-schema';
import { type EditorType } from '@/components/tiptap/types/index.enums';
import { Node, ReactNodeViewRenderer } from '@tiptap/react';
import { createSectionInputRules } from './section-input-rule';
import { SectionNodeComponent } from './section-node-component';

export interface SectionNodeStorage {
  /**
   * The host editor's type (note vs template), stamped by `BlockEditorMarkdown`.
   * Read by the `# ` input rule — which runs in ProseMirror, outside React — to
   * report `editor_context` on the `section_created` analytics event.
   */
  editorType: EditorType | undefined;
}

export const SectionNode = Node.create({
  ...sectionNodeSchemaSpec,

  addStorage(): SectionNodeStorage {
    return { editorType: undefined };
  },

  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => handleSectionHeadingEnter(editor),
      Tab: ({ editor }) => handleSectionTab(editor),
      'Shift-Tab': ({ editor }) => handleSectionShiftTab(editor),
    };
  },

  addInputRules() {
    return createSectionInputRules(() => this.storage.editorType);
  },

  addProseMirrorPlugins() {
    return [createLinkedHeadingGuardPlugin()];
  },

  addNodeView() {
    return ReactNodeViewRenderer(SectionNodeComponent);
  },
});
